/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './SectionHeader.scss';

import { first, isEmpty } from 'lodash';
import { arrayOf, bool, object, oneOfType, string } from 'prop-types';
import React from 'react';

import { FormattedDate } from 'components/shared/Text/Text';

import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

import { openBrokerageAuthTab } from 'services/ExternalAuthorizationURLBuilder';

const BrokerageOpenLink = () => (
  <a
    className="app-link"
    target="_blank"
    rel="noreferrer"
    onClick={() => openBrokerageAuthTab(undefined, 'ORDERSTATUS')}>
    View Open Orders.
  </a>
);

const BrokerageOpenLinkWithPermissions = WithUserPermissions(BrokerageOpenLink);

export const SectionHeader = ({
  className = '',
  title = 'Accounts',
  fromDate,
  toDate,
  accounts,
  hasBrokerage,
  isViewOnlyBrokerage
}) => {
  const accountId = !isEmpty(accounts) ? first(accounts).accountId : undefined;

  const brokerageLinkText =
    'Open orders for your Brokerage account are not listed below.';

  return (
    <div className={`section-header ${className}`}>
      <span className="section-header-title">{title}</span>
      {fromDate && !toDate && (
        <span className="section-header-date">
          As of <FormattedDate>{fromDate}</FormattedDate>
        </span>
      )}
      {fromDate && toDate && (
        <span className="section-header-date">
          <FormattedDate>{fromDate}</FormattedDate> through{' '}
          <FormattedDate>{toDate}</FormattedDate>
        </span>
      )}
      {hasBrokerage && accountId && !isViewOnlyBrokerage && (
        <span className="section-header-hasbrokerage">
          {brokerageLinkText}
          <BrokerageOpenLinkWithPermissions
            accountId={accountId}
            shouldDisable
          />
        </span>
      )}
    </div>
  );
};

SectionHeader.propTypes = {
  hasBrokerage: bool,
  accounts: arrayOf(object),
  title: oneOfType([string, object]),
  fromDate: string,
  toDate: string,
  isViewOnlyBrokerage: bool
};
